// src/helpers/toMonthDay.js

/*
 * Повертає дату у форматі "MM.DD" (за замовчуванням) без таймзонових зсувів.
 * Працює зі строками 'YYYY-MM-DD[..]', ISO, Date або timestamp.
 *
 * @param {string|Date|number} input - Значення дати: '2025-09-28', '2025-09-28 12:34', ISO, Date або число (ms).
 * @param {string} [sep='.'] - Роздільник між місяцем і днем (напр., '.' або '/').
 * @returns {string} Відформатована дата типу "MM.DD", або порожній рядок якщо вхід некоректний.
 */
export default function toMonthDay(input, sep = '.') {
	if (input == null || input === '') return '';

	// 1) Швидкий шлях для рядків формату YYYY-MM-DD...
	if (typeof input === 'string') {
		const m = input.match(/^(\d{4})[-/.](\d{2})[-/.](\d{2})/);
		if (m) return `${ m[2] }${ sep }${ m[3] }`;
	}

	// 2) Надійний шлях через Date для інших випадків
	const d = input instanceof Date ? input : new Date(input);
	if (Number.isNaN(d.getTime())) return '';

	const mm = String(d.getMonth() + 1).padStart(2, '0');
	const dd = String(d.getDate()).padStart(2, '0');
	return `${ mm }${ sep }${ dd }`;
}
